import styled from "styled-components";
import { theme } from "@theme";
import { motion } from "framer-motion";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
  flex: 1;
  height: fit-content;
  overflow-x: hidden;
  background: #F2EBE6;

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    padding: 60px 16px 30px 16px;
    gap: 0;
  }

  @media screen and (max-width: ${theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 92px 80px 30px 80px;
  max-width: 1440px;  
  gap: 32px;

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    padding: 16px 0 32px 0;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 104px;
  > div {
    flex: 1
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column;
    gap: 24px;
  }
`

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
`
export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  > div {
    margin-top: 80px;
  }
  @media (max-width: ${theme.breakpoints.sm}) {
    > div {
      margin-top: 0;
    }
  }
`
export const LeftTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`
export const Text = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 120%;
  color: #594E47;

`
export const Title = styled.div`
  font-family: Cormorant, sans-serif;
  font-weight: 500;
  font-size: 48px;
  line-height: 100%;
  color: #391D0A;
`
export const PhotoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  img {
    width: 100%;
  }
`
export const PhotoText = styled.div`
  font-family: Cormorant, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  color: #391D0A;
`
export const PhotosWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  
  > div:first-child {width: calc(43% - 8px)}
  > div:last-child {width: calc(57% - 8px)}
`

export const Quote = styled.div`
  margin: 96px 0 96px;
  font-family: Cormorant, sans-serif;
  font-weight: 500;
  font-size: 64px;
  line-height: 120%;
  text-align: center;

  color: #391D0A;

  @media (max-width: ${theme.breakpoints.sm}) {
    margin: 32px 0 32px;
    font-size: 32px;
  }
`

export const NewsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 104px;
  > div {
    flex: 1
  }
  @media (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column;
    gap: 24px;
    > div {
      flex: auto;
    }
  }
`

export const NewsTitle = styled.div`
  font-family: Cormorant, sans-serif;
  font-weight: 500;
  font-size: 48px;
  line-height: 120%;
`

export const MainNewsWrapper = styled.div``
export const SecondaryNewsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 16px;
`

export const NewsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  img {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
  }
`

export const NewsDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const NewsItemTitle = styled.div`
  font-family: Cormorant, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  color: #391D0A;

`
export const NewsItemDate = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  
  color: #89796E;
`

export const SliderWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`;

export const Slides = styled(motion.div)`
  display: flex;
  gap: 16px;
  will-change: transform;
`;

export const Slide = styled.div`
  min-width: 100%;
  padding: 0;
  box-sizing: border-box;

  img {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
  }
`;

export const Dots = styled.div`
  display: flex;
  justify-content: center;
`;

export const Dot = styled.button<{ active: boolean }>`
  width: 10px;
  height: 10px;
  margin: 0 6px;
  border-radius: 50%;
  border: none;
  background: ${({ active }) => (active ? '#333' : '#ccc')};
  cursor: pointer;
  padding: 0;
`;
